import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  SimpleGrid,
} from "@chakra-ui/react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CountrySelect } from "../../../components/country-select";
import { PhoneInput } from "../../../components/phone-input";
import { PersonalDetailsFormValues } from "./personal-details";
import { DateSelect } from "../../../components/date-select";

export const ProfileForm = () => {
  const { t } = useTranslation();
  const {
    control,
    register,
    formState: { errors },
    setValue,
    clearErrors,
    watch,
  } = useFormContext<PersonalDetailsFormValues>();

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} w="full">
      <FormControl isInvalid={!!errors.firstName} isRequired>
        <FormLabel fontSize="16px" fontWeight={600} color="slate.600">
          {t("personalDetails.form.firstName")}
        </FormLabel>
        <Input
          id="firstName"
          {...register("firstName")}
        />
        {errors.firstName?.message && (
          <FormErrorMessage>{errors.firstName.message}</FormErrorMessage>
        )}
      </FormControl>

      <FormControl isInvalid={!!errors.lastName} isRequired>
        <FormLabel fontSize="16px" fontWeight={600} color="slate.600">
          {t("personalDetails.form.lastName")}
        </FormLabel>
        <Input
          id="lastName"
          {...register("lastName")}
        />
        {errors.lastName?.message && (
          <FormErrorMessage>{errors.lastName.message}</FormErrorMessage>
        )}
      </FormControl>

      <FormControl isInvalid={!!errors.dateOfBirth} isRequired>
        <FormLabel fontSize="16px" fontWeight={600} color="slate.600">
          {t("personalDetails.form.dateOfBirth")}
        </FormLabel>
        <DateSelect
          id="dateOfBirth"
          onChange={(value) => {
            setValue("dateOfBirth", value);
            clearErrors("dateOfBirth");
            clearErrors("identityNumber");
          }}
          value={watch("dateOfBirth")}
        />
        {errors.dateOfBirth?.message && (
          <FormErrorMessage>{errors.dateOfBirth.message}</FormErrorMessage>
        )}
      </FormControl>

      <FormControl isInvalid={!!errors.phoneNumber} isRequired>
        <FormLabel fontSize="16px" fontWeight={600} color="slate.600">
          {t("personalDetails.form.phoneNumber")}
        </FormLabel>
        <Controller
          name="phoneNumber"
          control={control}
          render={({ field }) => (
            <PhoneInput
              id="phoneNumber"
              value={field.value}
              onChange={(value) => field.onChange(value)}
            />
          )}
        />
        {errors.phoneNumber?.message && (
          <FormErrorMessage>{errors.phoneNumber.message}</FormErrorMessage>
        )}
      </FormControl>

      <FormControl isInvalid={!!errors.identityNumber} isRequired>
        <FormLabel fontSize="16px" fontWeight={600} color="slate.600">
          {t("personalDetails.form.identityNumber")}
        </FormLabel>
        <Input
          id="identityNumber"
          {...register("identityNumber")}
        />
        {errors.identityNumber?.message && (
          <FormErrorMessage>{errors.identityNumber.message}</FormErrorMessage>
        )}
      </FormControl>

      <FormControl isInvalid={!!errors.country} isRequired>
        <FormLabel fontSize="16px" fontWeight={600} color="slate.600">
          {t("personalDetails.form.documentCountry")}
        </FormLabel>
        <Controller
          name="country"
          control={control}
          render={({ field }) => (
            <CountrySelect
              id="country"
              value={field.value}
              onChange={(value) => field.onChange(value)}
            />
          )}
        />
        {errors.country?.message && (
          <FormErrorMessage>{errors.country.message}</FormErrorMessage>
        )}
      </FormControl>
    </SimpleGrid>
  );
};
